import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { HreflangTags } from "@/components/HreflangTags";
import { getLanguageFromPath, getEnglishPath, getGermanPath, type SupportedLanguage } from "@/lib/language";

interface LanguageRouteProps {
  children: React.ReactNode;
}

export const LanguageRoute = ({ children }: LanguageRouteProps) => {
  const { i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const lang = getLanguageFromPath(location.pathname);

  useEffect(() => {
    if (i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
    document.documentElement.lang = lang === "en" ? "en" : "de";
  }, [lang, i18n]);

  return (
    <>
      {children}
      <HreflangTags />
    </>
  );
};




export const useLanguageSwitch = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const currentPath = location.pathname;
  const isEnglish = getLanguageFromPath(currentPath) === "en";

  const switchLanguage = () => {
    const target = isEnglish ? getGermanPath(currentPath) : getEnglishPath(currentPath);
    navigate(target, { replace: false });
  };

  return { isEnglish, switchLanguage, otherLanguage: isEnglish ? "de" : "en" };
};

export { getLanguageFromPath };
export type { SupportedLanguage };
